
/* colores viejos */
/* #48ffbb #3bff51 #3f49ff #9c9c9c */

export const lightest = '#f8f8ee';
export const lighter = '#dfdfdf';
export const light = '#d1d1d1';
export const gray = '#888888';
export const dark = '#262626';
export const darker = ' #161616';
export const darkest = '#000';

export const primary = '#ffc800';
export const secondary = '#ffc800';
export const terciary = '#7eae71';

export const accent = '#ffc800';

export const warning = '#ffc800';
export const approve = '#ffc800';